import { calendarResourcesQuery, calendarActiveLocationQuery } from './queries'

export const defaultGenericResourceProperties = {
	lastName: null,
	bookingEnabled: true,
	photo: null,
	phoneNumber: null,
	notifyBy: null,
	bio: null,
	__typename: 'User',
}

const createCalendarResolver = ({ cache }) => {
	// defaults

	cache.writeData({
		data: {
			calendarZoomLevel: localStorage.getItem('nw-calendar-zoom') || 'default',
			calendarDate: new Date().toString(),
			calendarInsertMode: 'appointment',
			activeLocation: null,
			activeAppointment: null,
			activeResource: {
				...defaultGenericResourceProperties,
				id: 'scheduled',
				firstName: 'All Scheduled Staff',
			},
			timelineInterval: 900,
			view: 'day',
		},
	})

	return {
		Mutation: {
			setZoomLevel: (root, { calendarZoomLevel }, ctx) => {
				localStorage.setItem('nw-calendar-zoom', calendarZoomLevel)
				ctx.cache.writeData({ data: { calendarZoomLevel } })
			},

			setCalendarInsertMode: (root, { mode = 'appointment' }, ctx) => {
				ctx.cache.writeData({ data: { calendarInsertMode: mode } })
				return null
			},
			setCalendarResource: (root, { resource }, ctx) => {
				const showAll = resource.id === 'all' || resource.id === 'scheduled'

				const data = { data: { activeResource: resource } }

				if (showAll) {
					data.data.view = 'day'
				}

				ctx.cache.writeData(data)
				return null
			},
			setLocation: (root, { location }, ctx) => {
				ctx.cache.writeData({ data: { activeLocation: location } })
				return null
			},
			setCalendarDate: (root, { date }, ctx) => {
				const data = { calendarDate: date.toString() }

				ctx.cache.writeData({ data })
				return null
			},
			setCalendarView: (root, { view }, ctx) => {
				const { activeLocation } = ctx.cache.readQuery({ query: calendarActiveLocationQuery })

				const { activeResource, employees } = ctx.cache.readQuery({
					query: calendarResourcesQuery,
					variables: {
						locationId: activeLocation.id,
					},
				})

				const data = { data: { view } }

				// Don't show all staff in 'week' view
				if ((activeResource.id === 'all' || activeResource.id === 'scheduled') && view === 'week') {
					data.data.activeResource = employees[0]
				}

				ctx.cache.writeData(data)
				return null
			},
		},
	}
}

export default createCalendarResolver
